export const DOCUMENT_STATISTICS_LABELS: { [entityType: string]: { [documentKey: string]: string } } = {
  company: {
    'documents.fraudWasteAndAbuseCertificateExpireDate': 'Fraud Waste & Abuse',
    'documents.hIPAATrainingExpireDate': 'HIPAA Training',
    'insurance.autoLiabilityInsuranceExpireDate': 'Auto Liability',
    'insurance.generalLiabilityInsuranceExpireDate': 'General Liability',
    'insurance.workerCOIImageExpireDate': 'Worker COI',
  },
  driver: {
    'examinations.phyExamExpireDate': 'Physical Exam',
    'examinations.drugTestExpireDate': 'Drug Test',
    'examinations.defensiveDrivingExpireDate': 'Defensive Driving',
    'examinations.wheelchairTrainingExpireDate': 'Wheelchair Training',
    'examinations.firstAidCprExpireDate': 'First Aid/CPR',
    'examinations.backgroundExpireDate': 'Background Check',
    'examinations.mvrExpireDate': 'MVR',
    'driverLicense.expireDate': 'Driver License',
  },
  vehicle: {
    'dates.registrationExpireDate': 'Registration',
    'dates.inspectionExpireDate': 'Inspection',
    'dates.insuranceReportExpireDate': 'Insurance Report',
  },
};

export function getDocumentStatisticLabel(entityType: string, documentKey: string): string {
  return DOCUMENT_STATISTICS_LABELS[entityType]?.[documentKey] || documentKey;
}
